import { render, staticRenderFns } from "./MembersUnionsDialog.vue?vue&type=template&id=a51ce6ce&scoped=true"
import script from "./MembersUnionsDialog.vue?vue&type=script&lang=js"
export * from "./MembersUnionsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51ce6ce",
  null
  
)

export default component.exports